import { LEGACY_KEY } from '@/config';
import type { AppState } from './state';
import type { Cam } from '@/engine/types';

interface LegacyState {
  cameras: Record<string, Cam>;
  onWall: (string | null)[];
  layout?: AppState['layout'];
  gutter?: AppState['gutter'];
  labels?: Record<string, string>;
  lastScan?: number | null;
  scanCache?: Record<string, { status: string; at: number }>;
  panelOpen?: boolean;
  sites?: string[];
}

/** Map the old single-file app's `kmitl-wall:v2` blob into the new state shape. */
export function migrateLegacy(): AppState | null {
  try {
    const raw = localStorage.getItem(LEGACY_KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as LegacyState;
    if (!v || !v.cameras) return null;
    return {
      cameras: v.cameras,
      onWall: Array.isArray(v.onWall) ? v.onWall : [],
      layout: v.layout ?? 'fit',
      gutter: v.gutter ?? 'dense',
      labels: v.labels ?? {},
      lastScan: v.lastScan ?? null,
      scanCache: v.scanCache ?? {},
      panelOpen: v.panelOpen ?? true,
      sites: v.sites ?? [],
      globalQuality: '360p',
      quality: {},
      view: { source: 'all', onlineOnly: false, unlimited: false },
    };
  } catch {
    return null;
  }
}
